import React from 'react';

import DeleteIcon from '../../assets/icons/DeleteIcon';
import UploadIcon from '../../assets/icons/UploadIcon';

import Button from '../shared/Button';
import Select from '../shared/Select';

const GtinsFilters = (props) => {
  const {
    onAddGtinClick,
    status,
    setStatus,
    statuses,
    onDelete,
    onUploadClick,
    classificationOptions,
    classification,
    setClassification,
    deletePermission,
  } = props;

  return (
    <div className='settings-cmp__filters--main'>
      <div className='settings-cmp__actions'>
        <Button
          text='Add GTIN'
          type='submit'
          onClick={onAddGtinClick}
        />

        <Button
          type='submit'
          width='60px'
          onClick={onUploadClick}
        >
          <UploadIcon color="#ffffff" />
        </Button>

        <Button
          type='icon'
          onClick={onDelete}
          disabled={!deletePermission}
        >
          <DeleteIcon style={{ color: '#000000' }}/>
        </Button>
      </div>

      <div className='settings-cmp__filters'>
        <Select
          value={classification}
          onChange={setClassification}
          options={classificationOptions}
          defaultLabel={`All (${classificationOptions.length})`}
          width={180}
        />

        <Select
          value={status}
          onChange={setStatus}
          options={statuses}
          defaultLabel={`All Status (${statuses.length})`}
          width={180}
        />
      </div>
    </div>
  )
};

export default GtinsFilters;
